import $ from 'jquery';

$(document).ready(function () {
	var search = $('[data-downloads-search]');

	if (search.length > 0) {
		search.keyup(function () {
			$('.js-filter-search-form').submit();
		});
	}
});


// WEBPACK FOOTER //
// ./scripts/downloads-search.js